export default __webpack_public_path__ + "static/media/trustT.93385006.jpg";